import React, { useContext, useEffect } from 'react'
import { Button, Input, SelectProps, Tooltip } from 'antd';
import { Select} from 'antd';
import { SlidersOutlined } from '@ant-design/icons';

//
import './FilterSection.css'
import { PokemonSet } from '../../Models/PokemonSet';
import { getAllPokemonSets } from '../../Api/Cards';
import { PromiseSesionContext } from '../../Machines/ErrorMachine';
import { RARITY } from '../../Statics/Rarity';
import FilterSectionPokemonMovil from '../FilterProducts/FilterSectionPokemonMovil';
import SideBarComponent from '../SideBarComponent/SideBarComponent';

interface Props{
  nameCard: string
  setNameCard: React.Dispatch<React.SetStateAction<string>>
  selectedSets: string[]
  setSelectedSets: React.Dispatch<React.SetStateAction<string[]>>
  selectedTypes: string[]
  setSelectedTypes: React.Dispatch<React.SetStateAction<string[]>>
  loading?: boolean
  type?: "inventary" | "all" | "cards"
  searchFunction: () => Promise<void>
}



const FilterSectionPokemon = ({nameCard, setNameCard, type, searchFunction, loading, selectedSets, setSelectedSets, selectedTypes, setSelectedTypes}:Props) => {
  const [sets, setSets] = React.useState<PokemonSet[]>([]);
  const [openResponsiveFilters, setOpenResponsiveFilters] = React.useState<boolean>(false);

  const [loadingComponent, setLoadingComponent] = React.useState<boolean>(false);
  const {error, sendError} = useContext(PromiseSesionContext);

  const selectProps: SelectProps = {
    value:selectedSets,
    onChange: setSelectedSets,
  };

  const selectPropsTypes: SelectProps = {
    value:selectedTypes,
    onChange: setSelectedTypes,
  };

  const sharedProps: SelectProps = {
    mode: 'multiple',
    style: { width: '100%' },
    placeholder: 'Seleccione los sets',
    maxTagCount: 'responsive',
  };

  const sharedPropsTypes: SelectProps = {
    mode: 'multiple',
    style: { width: '100%' },
    placeholder: 'Seleccione el tipo',
    maxTagCount: 'responsive',
  };

    const handleChange = (value: string) => {
      };
    
    const getAllSets = async () => {
      try{
        setLoadingComponent(true);
        const response = await getAllPokemonSets();
        setSets(response.reverse());
        setLoadingComponent(false);

      }
      catch(error){
        setLoadingComponent(false);
        sendError({type: "ERROR", data:{message:"Error al cargar los sets", type:"error"}})
      }
    }
    
    useEffect(() => {
      getAllSets();

    }, []);

  return (
    <div className='FilterSectionComponent'>
      <SideBarComponent open={openResponsiveFilters} setOpen={setOpenResponsiveFilters}>
        <FilterSectionPokemonMovil selectedSets={selectedSets} setSelectedSets={setSelectedSets} selectedTypes={selectedTypes} setSelectedTypes={setSelectedTypes} sets={sets} loading={loading} />
      {/* <FilterProducts loading={loading} filterIdioma={filterIdioma} filterTCG={filterTCG} filterTipo={filterTipo} setFilterIdioma={setFilterIdioma} setFilterTCG={setFilterTCG} setFilterTipo={setFilterTipo} /> */}
      </SideBarComponent>

        <Input 
        value={nameCard}
        disabled={loading} 
        onChange={(e)=>{setNameCard(e.target.value)}} 
        className='FilterSectionInput'
         placeholder="Nombre de la carta" />
    <div className='FilterSectionSelect-type'>
        <Select
        style={{ 
          width: "100%", 
          borderRadius: '0'  
        }}

        loading={loading && loadingComponent}
        onChange={handleChange}
        disabled={loading && loadingComponent}

        filterOption={(input, option) =>  
          option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
          || option?.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        {...sharedPropsTypes}
        {...selectPropsTypes}
        maxTagPlaceholder={(omittedValues) => (
          <Tooltip
            overlayStyle={{ pointerEvents: 'none' }}
            title={omittedValues.map(({ label }) => label).join(', ')}
          >
            <span>{omittedValues.length + " mas.."}</span>
          </Tooltip>
        )}
        >
          {RARITY.map((r:string)=> <Select.Option value={r}>{r}</Select.Option>) }
        </Select>


        </div> 

        <div className='FilterSectionSelect-end'>
        <Select
        style={{ 
          width: "100%", 
          borderRadius: '0'  
        }}

        loading={loading && loadingComponent}
        onChange={handleChange}
        disabled={loading && loadingComponent}

        filterOption={(input, option) =>  
          option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
          || option?.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        {...sharedProps}
        {...selectProps}
        maxTagPlaceholder={(omittedValues) => (
          <Tooltip
            overlayStyle={{ pointerEvents: 'none' }}
            title={omittedValues.map(({ label }) => label).join(', ')}
          >
            <span>{omittedValues.length + " mas.."}</span>
          </Tooltip>
        )}
        
        >
        {/* <Select.Option value={""}>Todos</Select.Option> */}
          {sets.map((set, index) => {
            return <Select.Option key={"setoption"+index} value={set.id}>{set.name}</Select.Option>
          })}
        </Select>



        </div> 
        <div className='filterPokemon-FilterButton' onClick={()=>{setOpenResponsiveFilters(true)}}>
        <SlidersOutlined />
        <span>Filtros</span>
      </div>
        {type==="all" &&
        <Button type='primary' onClick={()=>{searchFunction && searchFunction()}}>Buscar</Button>

        }
    </div>
  )
}

export default FilterSectionPokemon